import "jquery";
import  "./vendors/angular/angular.js";
import "zone.js";
import "bootstrap";
import "angular-ui-bootstrap";
import "angular-ui-router";

/* TODO: INFO: 
* One of the following dependecies use a lower version of Angular.js
*/
angular.lowercase = angular.$$lowercase; 
//END

import './vendors/angular-translate/angular-translate.min.js';
import './vendors/angular-translate/angular-translate-loader-static-files.js';
import './vendors/angular-translate/angular-translate-loader-url.min.js';
import './vendors/jquery-ui/jquery-ui.min.js';
import './vendors/pdfjs-dist/build/pdf.combined.min.js';
import './vendors/pdfjs-dist/web/pdf_viewer.js';